import React, { useRef, useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import NavHeader from '../shared/Nav-Header';
import styles from './project-networks.module.css'; // Use CSS modules
import GroupMessageBox from './GroupMessageBox';

const GuestProjectNetworks = () => {
    const [discipline, setDiscipline] = useState('');
    const [name, setName] = useState('');
    const [userId1, setUserId1] = useState('');
    const [profilePicture, setProfilePicture] = useState('');
    const [projectNetworkList, setProjectNetworkList] = useState([]);
    const [encourageReceived, setEncourageReceived] = useState([]);
    const [encourageSent, setEncourageSent] = useState([]);
    const [declinePolitely, setDeclinePolitely] = useState([]);
    const [declineHarshly, setDeclineHarshly] = useState([]);
    const [availableFreshNetworks, setAvailableFreshNetworks] = useState([]);
    const [notification, setNotification] = useState('');
    const [reload, setReload] = useState(false);
    const [groupName, setGroupName] = useState('');
    const [selectedNetworks, setSelectedNetworks] = useState([]);
    const [showGroupCreation, setShowGroupCreation] = useState(false);
    const [myGroups, setMyGroups] = useState([]);
    const [activeGroupChat, setActiveGroupChat] = useState(null);
    const pnRef = useRef(null);
    const navigate = useNavigate();
    const token = useMemo(() => localStorage.getItem('token'), []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // if (!token) {
                //     localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                //     navigate('/login');
                //     return;
                // }
                const response = await axios.post('/api/guest/pn/all-networks');
                // console.log(response.data);
                const { discipline, name, profilePicture, projectNetworkList, encourageReceived, encourageSent, declinePolitely, declineHarshly, availableFreshNetworks } = response.data.pnLists;
                setDiscipline(discipline);
                setName(name);
                setProfilePicture(profilePicture);
                setProjectNetworkList(projectNetworkList);
                setEncourageReceived(encourageReceived);
                setEncourageSent(encourageSent);
                setDeclinePolitely(declinePolitely);
                setDeclineHarshly(declineHarshly);
                setAvailableFreshNetworks(availableFreshNetworks);
                // console.log('Discipline:', discipline);
                // console.log('Name:', name);
                // console.log('Profile Picture:', profilePicture);
                // console.log('Project Network List:', projectNetworkList);
                // console.log('Encourage Received:', encourageReceived);

                // console.log('Encourage Sent:', encourageSent);
                // console.log('Decline Politely:', declinePolitely);
                // console.log('Decline Harshly:', declineHarshly);
                // console.log('Available Fresh Networks:', availableFreshNetworks);
            } catch (error) {
            //     const errorMessage = error.response?.data?.message || 'Error fetching project networks data';
            //     console.error(errorMessage);
            //     setNotification('Error fetching project networks data. Please try again.');
            }
        };

        if (reload) {
            window.location.reload();
        }
        fetchData();
    }, [navigate, reload]);

    // useEffect(() => {
    //     const fetchGroups = async () => {
    //         try {
    //             const response = await axios.get('/api/group/my-groups', {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`
    //                 }
    //             });
    //             setMyGroups(response.data.groups);
    //             setUserId1(response.data.userId);
    //         } catch (error) {
    //             console.error('Error fetching user groups:', error);
    //         }
    //     };

    //     fetchGroups();
    // }, []);

    const handleEncourage = async (networkId) => {
        try {
            await axios.post('/api/pn/encouraged', { networkId }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setNotification('Encouragement sent successfully!');
            setEncourageSent([...encourageSent, networkId]);
            setAvailableFreshNetworks(availableFreshNetworks.filter(network => network._id !== networkId));
            setReload(true);
        } catch (error) {
            console.error('Error sending encouragement:', error);
            setNotification('Error sending encouragement. Please try again.');
        }
    };

    const handleEncourageSupport = async (networkId) => {
        try {
            await axios.post('/api/guest/pn/encourage-support', { networkId }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setNotification('Encouragement supported successfully!');
            setEncourageReceived(encourageReceived.filter(network => network._id !== networkId));
            setAvailableFreshNetworks(projectNetworkList.filter(network => network._id !== networkId));
            setReload(true);
        } catch (error) {
            console.error('Error supporting encouragement:', error);
            setNotification('Error supporting encouragement. Please try again.');
        }
    };

    const handleRemoveNetwork = async (networkId) => {
        try {
            await axios.post('/api/guest/pn/remove-network', { networkId }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setNotification('Network Removed!');
            setProjectNetworkList([...availableFreshNetworks, { _id: networkId }]);
            setReload(true);
        } catch (error) {
            console.error('Error network removing:', error);
            setNotification('Error network removing. Please try again.');
        }
    };

    const handleDiscourage = async (networkId, type) => {
        try {
            await axios.post('/api/guest/pn/discouraged', { networkId, type }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setNotification(`Encouragement ${type === 'polite' ? 'declined politely' : 'declined harshly'}.`);
            setEncourageReceived(encourageReceived.filter(network => network._id !== networkId));
            if (type === 'polite') {
                setDeclinePolitely([...declinePolitely, { _id: networkId, name: "Unknown" }]);
            } else {
                setDeclineHarshly([...declineHarshly, { _id: networkId, name: "Unknown" }]);
            }
        } catch (error) {
            console.error('Error declining encouragement:', error);
        }
    };

    const handleMessage = (networkId) => {
        navigate(`/messages`);
    };

    const handleCreateGroup = async () => {
        try {
            const response = await axios.post('/api/group/create-group', {
                groupName,
                userIds: selectedNetworks
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification('Group created successfully!');
                setGroupName('');
                setSelectedNetworks([]);
                setShowGroupCreation(false);
            }
        } catch (error) {
            console.error('Error creating group:', error);
            const errorMessage = error.response?.data?.message || 'Error creating group. Please try again.';
            setNotification(errorMessage);
        }
    };

    const handleSelectNetwork = (networkId) => {
        setSelectedNetworks((prevSelected) => {
            if (prevSelected.includes(networkId)) {
                return prevSelected.filter(id => id !== networkId);
            } else {
                return [...prevSelected, networkId];
            }
        });
    };

    const handleCloseNotification = () => {
        setNotification('');
    };

    const handleShowGroupCreation = () => {
        if(showGroupCreation) {
            setShowGroupCreation(false);
        } else {
            setShowGroupCreation(true);
        }
    };

    const handleGroupChatClick = async (group) => {
        setActiveGroupChat(group);
    };

    const handleCloseChat = () => {
        setActiveGroupChat(null);
    };

    const handleScrollToPN = () => {
        if (pnRef.current) {
            pnRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <>
            <NavHeader />

            <header className={styles.headerContainer}>
            <div className={styles.headerContent}>
                <div className={styles.titleSection}>
                    <h1 className={styles.mainTitle}>
                        ✨ Welcome to Our Project Networks! ✨
                    </h1>
                    <div className={styles.tagline}>
                        <span className={styles.taglineText}>Create. Collaborate. Innovate.</span>
                    </div>
                </div>

                <div className={styles.heroSection}>
                    <div className={styles.heroImageContainer}>
                        <div className={styles.heroImage}>
                            <div className={styles.collaborationIcon}>🤝</div>
                            <div className={styles.techIcon}>💻</div>
                            <div className={styles.networkIcon}>🌐</div>
                            <div className={styles.innovationIcon}>💡</div>
                        </div>
                    </div>
                    
                    <div className={styles.heroText}>
                        <p className={styles.welcomeMessage}>
                            Got no social groups? Don't worry, we got you covered! 
                            <span className={styles.highlight}> Join groups now to:</span>
                        </p>
                        
                        <div className={styles.featuresGrid}>
                            <div className={styles.feature}>
                                <div className={styles.featureIcon}>🚀</div>
                                <div className={styles.featureContent}>
                                    <h3>DO PROJECTS</h3>
                                    <p>Collaborate on exciting projects with like-minded individuals and bring your ideas to life!</p>
                                </div>
                            </div>
                            
                            <div className={styles.feature}>
                                <div className={styles.featureIcon}>📚</div>
                                <div className={styles.featureContent}>
                                    <h3>LEARN</h3>
                                    <p>Acquire new skills and knowledge from experts and peers in a supportive environment.</p>
                                </div>
                            </div>
                            
                            <div className={styles.feature}>
                                <div className={styles.featureIcon}>🎯</div>
                                <div className={styles.featureContent}>
                                    <h3>TEACH</h3>
                                    <p>Share your expertise and help others grow and develop their skills.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

               <div className={styles.benefitsSection}>
                    <h2 className={styles.benefitsTitle}>🌟 Our Project Networks is perfect for you to: 🌟</h2>
                    <div className={styles.benefitsList}>
                        <div className={styles.benefit}>
                            <span className={styles.benefitIcon}>💫</span>
                            <span>Connect with people who share similar interests and passions</span>
                        </div>
                        <div className={styles.benefit}>
                            <span className={styles.benefitIcon}>🎨</span>
                            <span>Develop new skills and enhance your professional portfolio</span>
                        </div>
                        <div className={styles.benefit}>
                            <span className={styles.benefitIcon}>🤝</span>
                            <span>Build meaningful relationships and networks</span>
                        </div>
                        <div className={styles.benefit}>
                            <span className={styles.benefitIcon}>📈</span>
                            <span>Stay updated with the latest trends and technologies</span>
                        </div>
                    </div>
                </div>

                <div className={styles.ctaSection}>
                    <p className={styles.ctaText}>
                        Join us today and become a part of a dynamic and innovative community 
                        that is shaping the future of collaboration and project management!
                    </p>
                    <button className={styles.ctaButton} onClick={handleScrollToPN}>
                        🎊 Join Our Amazing Community! 🎊
                    </button>
                </div>
            </div>
        </header>
            <div ref={pnRef} className={styles.projectNetworksContainer}>
                {notification && (
                    <div className={styles.projectNetworksNotification}>
                        <p>{notification}</p>
                        <button onClick={handleCloseNotification}>Close</button>
                    </div>
                )}
                
                {/* Emotional status banner */}
                <div className={styles.emotionalStatusBanner}>
                    <p>💕 You have {projectNetworkList?.length || 0} amazing connections! Let's make more today! 💕</p>
                </div>

                <div className={styles.profileSection}>
                    <img 
                    src={profilePicture ? profilePicture.replace('/upload/', '/upload/w_384,h_400,c_fill/') : '/default-profile.png'}
                    alt="pfp" className={styles.profilePicture} />
                    <div className={styles.profileInfo}>
                        <h2>{name} ✨</h2>
                        <p>{discipline}</p>
                        <p className={styles.socialStatus}>🌟 Building meaningful connections every day! 🌟</p>
                    </div>
                </div>

                <div className={styles.networksSection}>
                    <h3>💖 Your Precious Network Family 💖</h3>
                    <p className={styles.sectionSubtext}>These wonderful people are part of your journey!</p>
                    <ul>
                        {projectNetworkList?.map(network => (
                            <li key={network._id} className={styles.networkItem}>
                                <div className={styles.networkInfo}>
                                    <span className={styles.networkName}>💫 {network.name} 💫</span>
                                    <span className={styles.connectionTime}>Connected for {Math.floor(Math.random() * 30) + 1} days</span>
                                </div>
                                
                                {showGroupCreation && <input
                                    type="checkbox"
                                    checked={selectedNetworks.includes(network._id)}
                                    onChange={() => handleSelectNetwork(network._id)}
                                />}
                                
                                <div className={styles.networkActions}>
                                    <button onClick={() => handleMessage(network._id)} className={styles.primaryAction}>
                                        💬 Say Hi!
                                    </button>
                                    <button onClick={() => handleRemoveNetwork(network._id)} className={styles.secondaryAction}>
                                        😢 Remove (We'll miss them!)
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>
                    {(!projectNetworkList || projectNetworkList.length === 0) && (
                        <div className={styles.emptyState}>
                            <p>🥺 No connections yet? Let's find some amazing people to connect with! 🥺</p>
                        </div>
                    )}
                </div>

                <div className={styles.createGroupSection}>
                    <h3>🎉 Create Your Own Circle of Joy! 🎉</h3>
                    <p className={styles.sectionSubtext}>Bring your favorite people together!</p>
                    <button onClick={handleShowGroupCreation} className={styles.primaryAction}>
                        ✨ Start Creating Magic ✨
                    </button>
                    {showGroupCreation && (
                        <div className={styles.groupCreationForm}>
                            <h4>🌈 Give Your Group a Special Name 🌈</h4>
                            <input
                                type="text"
                                value={groupName}
                                onChange={(e) => setGroupName(e.target.value)}
                                placeholder="Something that brings you all together... 💕"
                                className={styles.groupNameInput}
                            />
                            <button onClick={handleCreateGroup} className={styles.createButton}>
                                🎊 Create Our Beautiful Group! 🎊
                            </button>
                        </div>
                    )}
                </div>

                <div className={styles.myGroupsSection}>
                    <h3>👥 Your Amazing Groups 👥</h3>
                    <p className={styles.sectionSubtext}>These are your special communities!</p>
                    <ul>
                        {myGroups?.map(group => (
                            <li key={group._id} onClick={() => handleGroupChatClick(group)} className={styles.groupItem}>
                                <span className={styles.groupName}>🌟 {group.name} 🌟</span>
                                <span className={styles.groupMembers}>{Math.floor(Math.random() * 8) + 2} wonderful members</span>
                                <div className={styles.groupActivity}>
                                    <span className={styles.activityIndicator}>💚 Active now!</span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    {(!myGroups || myGroups.length === 0) && (
                        <div className={styles.emptyState}>
                            <p>🌱 No groups yet? Create your first one and watch the magic happen! 🌱</p>
                        </div>
                    )}
                </div>

                {activeGroupChat && (
                    <GroupMessageBox group={activeGroupChat} onClose={handleCloseChat} />
                )}

                <div className={styles.encourageReceivedSection}>
                    <h3>💝 People Who Want to Connect With You! 💝</h3>
                    <p className={styles.sectionSubtext}>Look how popular you are! They're waiting for your response 🥰</p>
                    <ul>
                        {encourageReceived?.map(network => (
                            <li key={network._id} className={styles.encourageItem}>
                                <div className={styles.encourageInfo}>
                                    <span className={styles.encouragerName}>💕 {network.name} 💕</span>
                                    <span className={styles.encourageMessage}>is excited to connect with you!</span>
                                </div>
                                <div className={styles.encourageActions}>
                                    <button onClick={() => handleEncourageSupport(network._id)} className={styles.acceptButton}>
                                        🎉 Yes! Let's Connect! 🎉
                                    </button>
                                    <button onClick={() => handleDiscourage(network._id, 'polite')} className={styles.politeDecline}>
                                        😊 Maybe Later
                                    </button>
                                    <button onClick={() => handleDiscourage(network._id, 'harsh')} className={styles.harshDecline}>
                                        😔 Not Right Now
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>
                    {(!encourageReceived || encourageReceived.length === 0) && (
                        <div className={styles.emptyState}>
                            <p>🌟 No new connection requests right now, but keep being amazing! 🌟</p>
                        </div>
                    )}
                </div>

                <div className={styles.encourageSentSection}>
                    <h3>🚀 Your Outgoing Connection Requests 🚀</h3>
                    <p className={styles.sectionSubtext}>You're being so proactive! We love to see it! 💪</p>
                    <ul>
                        {encourageSent?.map(network => (
                            <li key={network._id} className={styles.sentItem}>
                                <span className={styles.sentName}>⏰ {network.name}</span>
                                <span className={styles.sentStatus}>Waiting for their response... 🤞</span>
                            </li>
                        ))}
                    </ul>
                    {(!encourageSent || encourageSent.length === 0) && (
                        <div className={styles.emptyState}>
                            <p>💡 Why not reach out to someone new today? Spread the love! 💡</p>
                        </div>
                    )}
                </div>

                <div className={styles.declinePolitelySection}>
                    <h3>😌 Gentle Raincheck Responses 😌</h3>
                    <p className={styles.sectionSubtext}>These lovely people said "maybe later" - there's still hope! 🌈</p>
                    <ul>
                        {declinePolitely?.map(network => (
                            <li key={network._id} className={styles.declineItem}>
                                <span>💛 {network.name} 💛</span>
                                <span className={styles.declineNote}>Perhaps they'll be ready soon! 🌸</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className={styles.declineHarshlySection}>
                    <h3>💙 Learning Experiences 💙</h3>
                    <p className={styles.sectionSubtext}>Not every connection is meant to be, and that's okay! 🌺</p>
                    <ul>
                        {declineHarshly?.map(network => (
                            <li key={network._id} className={styles.declineItem}>
                                <span>🌻 {network.name} 🌻</span>
                                <span className={styles.declineNote}>We respect their choice! 🕊️</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className={styles.availableFreshNetworksSection}>
                    <h3>🌟 Amazing New People to Meet! 🌟</h3>
                    <p className={styles.sectionSubtext}>Fresh connections are waiting! Your next best friend might be here! 🎯</p>
                    <ul>
                        {availableFreshNetworks?.map(network => (
                            <li key={network._id} className={styles.freshNetworkItem}>
                                <img 
                                src={network.profilePicture ? network.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : '/default-profile.png'}
                                alt="pfp" className={styles.networkProfilePicture} />
                                <div className={styles.freshNetworkInfo}>
                                    <span className={styles.freshNetworkName}>✨ {network.name} ✨</span>
                                    <span className={styles.freshNetworkMeta}>New member • {Math.floor(Math.random() * 100) + 1}% compatibility!</span>
                                </div>
                                <button onClick={() => handleEncourage(network._id)} className={styles.encourageButton}>
                                    💫 Let's Connect! 💫
                                </button>
                            </li>
                        ))}
                    </ul>
                    {(!availableFreshNetworks || availableFreshNetworks.length === 0) && (
                        <div className={styles.emptyState}>
                            <p>🔄 Check back soon! New amazing people join every day! 🔄</p>
                        </div>
                    )}
                </div>

                {/* Persistent motivation footer */}
                <div className={styles.motivationFooter}>
                    <p>🌈 Remember: Every connection is a new adventure! Keep spreading joy! 🌈</p>
                    <p>💖 You're doing great at building your community! 💖</p>
                </div>
            </div>
        </>
    );
};

export default GuestProjectNetworks;